// extracted by mini-css-extract-plugin
module.exports = {"list":"_7a3fb80146--list--xVIhI","label":"_7a3fb80146--label--klecL","input":"_7a3fb80146--input--RAbDx","icon":"_7a3fb80146--icon--iF5df"};